// extracted by mini-css-extract-plugin
export default {"carousel":"photo_slider_carousel__elI9w","carouselItem":"photo_slider_carouselItem__V84Gw","boxArrows":"photo_slider_boxArrows__dY4ad"};